import { defineMobileWindow } from "@app/overlay";
import { ManualBarcodeEntryForm, type ManualBarcodeEntryFormProps } from "./ManualBarcodeEntryForm";

/**
 * Overlay-окно ручного ввода штрихкода (имитация аппаратного скана).
 *
 * `blocking: true` — нормальная modal-политика: hardware wedge глушится через
 * `globalSuppress`. Inject идёт не в live active entry, а в `scanTarget`,
 * захваченный до открытия окна.
 */
export const manualBarcodeEntryWindows = {
    main: defineMobileWindow<ManualBarcodeEntryFormProps>({
        key: "app.scanner.manualBarcode",
        title: "Ввод штрихкода",
        blocking: true,
        placement: "center",
        reuse: "focus-existing",
        closeOnEscape: true,
        closeOnBackdropClick: true,
        component: ManualBarcodeEntryForm,
    }),
};
